getFragmentRef